"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

function _typeof(obj) { if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } return _assertThisInitialized(self); }

function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }

function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); if (superClass) _setPrototypeOf(subClass, superClass); }

function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }

var AutoCompleteInput =
/*#__PURE__*/
function (_Backbone$View) {
  _inherits(AutoCompleteInput, _Backbone$View);

  _createClass(AutoCompleteInput, [{
    key: "template",
    value: function template(_ref) {
      var className = _ref.className,
          id = _ref.id,
          label = _ref.label;
      return "\n            <div class=\"ui-widget autoComplete ".concat(className, "\">\n                <input id=\"").concat(id, "\" aria-label=\"").concat(label, "\" type=\"search\" name=\"search\">\n                <label class=\"inputLabel\" for=\"").concat(id, "\" title=\"").concat(label, "\">").concat(label, "</label>\n                <i class=\"icon-down-arrow\" aria-hidden=\"true\"></i>\n                <div class=\"results\"><div>\n            </div>");
    }
  }]);

  function AutoCompleteInput(_ref2) {
    var _this;

    var className = _ref2.className,
        id = _ref2.id,
        label = _ref2.label,
        fieldList = _ref2.fieldList,
        defaultField = _ref2.defaultField,
        selectedEvent = _ref2.selectedEvent;

    _classCallCheck(this, AutoCompleteInput);

    _this = _possibleConstructorReturn(this, _getPrototypeOf(AutoCompleteInput).apply(this, arguments));

    _.extend(_assertThisInitialized(_this), arguments[0]);

    _this.defaultField = defaultField || '';

    _this.selectedEvent = selectedEvent || function () {};

    return _this;
  }

  _createClass(AutoCompleteInput, [{
    key: "render",
    value: function render() {
      this.$el.empty().append(this.template(this));
      this.$input = this.$el.find('input');

      if (this.defaultField) {
        this.lastSelected = this.defaultField;
        this.$input.val(this.defaultField);
        this.$el.find('.inputLabel').addClass('secondary-color');
        this.$el.find('.autoComplete').addClass('focused');
      }

      this.$input.autocomplete({
        source: this.fieldList,
        appendTo: this.$el.find('.results'),
        minLength: 0
      }).autocomplete('widget').addClass('fixed-height');

      this._attachEvents();

      return this;
    }
  }, {
    key: "_attachEvents",
    value: function _attachEvents() {
      var _this2 = this;

      this.$input.on('focus click', function () {
        _this2.$input.val('');

        _this2.$input.autocomplete('search', '');
      });
      this.$input.on('autocompleteselect', function (event, target) {
        _this2.$input.val(target.item.label);

        _this2.selectedEvent(target.item.label);

        _this2.lastSelected = target.item.label;
      });
      this.$el.find('.icon-down-arrow').on('click', function () {
        _this2.$input.click().focus();
      });
      this.$input.on('focus', function () {
        _this2.$el.find('.autoComplete').find('.inputLabel').addClass('secondary-color');

        _this2.$el.find('.autoComplete').addClass('focused');
      });
      this.$input.on('blur', function () {
        if (_this2.lastSelected) {
          _this2.$input.val(_this2.lastSelected);
        }

        if (!_this2.$input.val()) {
          _this2.$el.find('.inputLabel').removeClass('secondary-color');

          _this2.$el.find('.autoComplete').removeClass('focused');
        }
      });
    }
  }]);

  return AutoCompleteInput;
}(Backbone.View);

exports["default"] = AutoCompleteInput;